module.exports = __webpack_public_path__ + "static/media/roiMainStandIn.18ebdda9.png";